module.exports = __webpack_public_path__ + "media/band.f30d5572.webm";